export default __webpack_public_path__ + "static/media/stripe-light.aa8055c4.svg";